export default {
  title: 'Servicegebühr-Umsatzrechner',
  description:
    'Schätzung, was die Servicegebühr pro Monat einbringt. Die Zahlen aktualisieren sich während der Eingabe.',
  authoritative:
    'Der Prozentsatz und die maximale Gebühr unten sind die Einstellungen, die angewendet werden. Durchschnittlicher Bestellwert und monatlicher GMV sind nur Schätzungen.',
  off_notice:
    'Die Servicegebühr ist bei diesem Restaurant ausgeschaltet und bringt daher noch nichts ein. Speichern Sie oben eine Gebühr, um sie zu aktivieren.',
  fields: {
    recommended: 'Empfohlen: {{value}}',
    aov: {
      label: 'Durchschnittlicher Bestellwert',
      help: 'Typischer Warenkorbwert im Online-Bestellsystem.',
      placeholder: 'z. B. 32,50',
    },
    percentage: {
      label: 'Servicegebühr in Prozent',
      help: 'Zwischen {{min}} % und {{max}} %.',
    },
    max_amount: {
      label: 'Maximale Gebühr pro Bestellung',
      help: '{{max}} ist das Plattform-Maximum.',
      below_min: 'Die maximale Gebühr muss mindestens {{min}} betragen.',
    },
    monthly_gmv: {
      label: 'Monatlicher GMV',
      help: 'Gesamter Bestellwert, der pro Monat abgewickelt wird.',
      placeholder: 'z. B. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Geschätzter monatlicher Partner-Umsatz',
    approximate: 'Ungefährer Wert auf Basis der obigen Angaben — der tatsächliche Umsatz wird abweichen.',
    estimate_inputs: 'Basierend auf dem geschätzten Bestellwert und GMV — der tatsächliche Umsatz wird abweichen.',
    share: 'Das entspricht dem Partner-Anteil von {{share}} % an der insgesamt erhobenen Servicegebühr.',
    total_collected: 'Insgesamt an der Kasse von Gästen erhobene Servicegebühr',
    total_collected_note: '— von Gästen bezahlt, kein zusätzlicher Umsatz zum obigen Wert.',
    effective_rate: 'Effektiver Gebührensatz über alle Bestellungen',
  },
};
